import { Button, ButtonVariants } from '@comptia-sso/core';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

// Styles.
import styles from './InstructorApproverHeader.module.scss';

export const InstructorApproverAddHeader = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const institutionId = searchParams.get('institutionId');

  return (
    <header className={styles.header}>
      <div className={styles.title}>
        <h1>Add Instructor Approver</h1>
      </div>
      <div className={styles.breadcrumb}>
        <Button
          className={styles.back}
          link
          to={
            institutionId
              ? `/consent-approvers/institutions/${institutionId}`
              : '/consent-approvers'
          }
          variant={ButtonVariants.Secondary}
        >
          Back
        </Button>
      </div>
    </header>
  );
};
